<template>
  <div
    class="preview"
    @click.self="cancel"
  >
    <div class="preview-content">
      <img
        class="phone-img"
        src="@/assets/images/phone.png"
        alt="phone"
        width="340"
      >
      <iframe
        :src="linkUrl + '&iframeData=yes&view=yes'"
        class="preview-iframe"
        frameborder="0"
        @load="iframeOnLoad"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    context: {
      type: String,
      default: ''
    },
    dialogData: {
      type: Object,
      default () {
        return {}
      }
    },
    showTime: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      linkUrl: ''
    }
  },
  created () {
    const { linkUrl } = this.util.createH5Url({
      _id: 'iframe',
      sourceType: 2
    }, 'article', this.$projectScene, true)
    this.linkUrl = linkUrl
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    iframeOnLoad () {
      this.loading = false
      this.previewIframeDom = document.querySelector('.preview-iframe')
      this.postMessage({
        title: this.dialogData.title,
        cover: this.dialogData.cover,
        context: this.dialogData.context,
        sourceType: 2,
        shareName: this.dialogData.shareName,
        showTime: this.showTime,
        author: this.dialogData.author,
        qrCodeId: this.dialogData.qrCodeInfo.qrCodeId
      })
    },
    postMessage (postData) {
      let data = {
        _id: 'iframe',
        sourceType: 2
      }

      this.previewIframeDom.contentWindow.postMessage({
        postType: 'data',
        postData: postData
      }, this.linkUrl)
    }
  }
}
</script>
<style lang="scss" scoped>
.preview {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  .preview-content {
    width: 340px;
    height: 580px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    iframe {
      width: 300px;
      height: 504px;
      overflow-x: hidden;
      overflow-y: auto;
      position: absolute;
      top: 36px;
      left: 20px;
    }
  }
}
</style>
